import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=0afee168&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./MainLayout.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=0afee168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afee168",
  null
  
)

export default component.exports